<div class="chat-container">
    <!-- Chat Bubble Button -->
    <button class="chat-bubble" (click)="toggleChat()" [class.active]="isChatOpen">
        <mat-icon *ngIf="!isChatOpen">auto_awesome</mat-icon>
        <mat-icon *ngIf="isChatOpen">close</mat-icon>
    </button>

    <!-- Chat Panel -->
    <div class="chat-panel" [class.open]="isChatOpen">
        <div class="chat-header">
            <div class="chat-title">AI Chat</div>
            <button class="close-button" (click)="toggleChat()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="chat-messages" #messagesContainer>
            <!-- Empty state when no message exchange has happened -->
            <div *ngIf="messages.length === 1" class="empty-state">
                <div class="sparkle-icon">
                    <mat-icon>auto_awesome</mat-icon>
                </div>
                <p class="empty-state-text">Ask our AI anything</p>
            </div>

            <!-- Messages list -->
            <div *ngFor="let message of messages" class="message" [class.user-message]="message.isUser"
                [class.ai-message]="!message.isUser" [class.welcome-message]="isWelcomeMessage(message)">
                <div class="message-bubble">
                    <div class="message-text">{{ message.text }}</div>
                </div>
            </div>
        </div>

        <div class="chat-input">
            <div class="input-container">
                <input type="text" placeholder="Type message" [(ngModel)]="userMessage"
                    (keydown)="handleKeyDown($event)">
                <button class="send-button" (click)="sendMessage()" [disabled]="!userMessage.trim()">
                    <mat-icon>send</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>